import { useGetBreakpointPropValue, } from "./useGetBreakpointPropValue";
/**
 * Use this hook if you want to get the current `BreakpointVariant`
 *
 * This hook only works inside a `<Breakpoints />` component
 */
export const useBreakpointPropValue = (value) => {
    return useGetBreakpointPropValue()(value);
};
export default useBreakpointPropValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQnJlYWtwb2ludFByb3BWYWx1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VCcmVha3BvaW50UHJvcFZhbHVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFFTCx5QkFBeUIsR0FDMUIsTUFBTSw2QkFBNkIsQ0FBQztBQUVyQzs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsQ0FDcEMsS0FBNEIsRUFDTixFQUFFO0lBQ3hCLE9BQU8seUJBQXlCLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUM1QyxDQUFDLENBQUM7QUFFRixlQUFlLHNCQUFzQixDQUFDIn0=